import { useContext } from "react";
import PokeContext from "../context";

export default function Header() {
    const { favorites } = useContext(PokeContext);

	let imgUrl =
		'https://raw.githubusercontent.com/PokeAPI/media/master/logo/pokeapi_256.png';

    return(
        <header>
            <div />
            <div>
				<img src={imgUrl} alt="pokeapi-logo" className="navbar-image" />
			</div>

			<div style={{ fontSize: 25, width: 70 }}>❤️ {favorites.length}</div>
        </header>
    );
}
